import { userinfoAtom } from "../../../../api_channel/channel_state_jotai";
import { useAtomValue } from "../../../../app-jotai";

import { t } from "../../../../../packages/excalidraw/i18n";

import { useDocumentNavigator } from "../../hooks/useDocumentNavigator";

import "./FooterUI.scss";

import type { ExcalidrawImperativeAPI } from "../../../../../packages/excalidraw/types";

interface IFooterUIProps {
  excalidrawAPI: ExcalidrawImperativeAPI;
}

const ArrowPre = (
  <svg
    className="p-arrow"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 19L8 12L15 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ArrowNext = (
  <svg
    className="p-arrow"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 5L16 12L9 19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FooterUI = () => {
  const {
    disableNext,
    disablePre,
    currentPage,
    totalPages,
    setNextPage,
    setPrevPage,
  } = useDocumentNavigator();

  const currentUser = useAtomValue(userinfoAtom);
  const isAdmin = currentUser?.metadata?.is_admin;
  const isPresenter = currentUser?.metadata?.is_presenter;
  const isRecorder = currentUser?.isRecorder;

  const handlePre = () => {
    setPrevPage();
  };

  const handleNext = () => {
    setNextPage();
  };
  const Pager = () => {
    if (totalPages === 0) {
      return null;
    }

    return (
      <div className="footer-container">
        <button className="pre" onClick={handlePre} disabled={disablePre}>
          {ArrowPre}
        </button>
        <div className={`footer-participant-container `}>
          {t("whiteboard.page", { count: currentPage[1] })}
        </div>

        <button className="next" onClick={handleNext} disabled={disableNext}>
          {ArrowNext}
        </button>
      </div>
    );
  };
  const renderForAdmin = () => {
    return (
      <>
        <Pager />
      </>
    );
  };
  // TODO: implement take over presenter
  // const takeOverPresenter = async () => {
  //   const body = new SwitchPresenterReq({
  //     userId: currentUser?.userId,
  //     task: SwitchPresenterTask.PROMOTE,
  //   });

  //   const r = await sendAPIRequest(
  //     "switchPresenter",
  //     body.toBinary(),
  //     false,
  //     "application/protobuf",
  //     "arraybuffer",
  //   );
  //   const res = CommonResponse.fromBinary(new Uint8Array(r));

  //   if (res.status) {
  //     toast(t("left-panel.menus.notice.presenter-changed"), {
  //       toastId: "lock-setting-status",
  //       hideProgressBar: true,
  //       icon: <Info24Filled />,
  //       style: isMobile ? { top: "50px", left: "1px" } : {},
  //     });
  //   } else {
  //     toast(t(res.msg), {
  //       toastId: "lock-setting-status",
  //       type: "error",
  //       icon: <ErrorCircle20Filled className="text-[#E5484D]" />,
  //       hideProgressBar: true,
  //       style: isMobile ? { top: "50px", left: "1px" } : {},
  //     });
  //   }
  // };

  const renderForParticipant = () => {
    return (
      <div
        className={`footer-participant-container ${
          isAdmin && !isRecorder ? "admin-recorder-padding" : "default-padding"
        }`}
      >
        {/* {isAdmin && !isRecorder ? (
          <button
            className="w-8 h-8 rounded-lg border border-solid border-[#3d3d3d] text-[#3d3d3d] dark:text-[#b8b8b8] dark:bg-[#262627] dark:hover:bg-[#3d3d3d] hover:bg-[#3d3d3d] hover:text-[#b8b8b8] flex items-center justify-center ltr:mr-2 rtl:ml-2"
            onClick={takeOverPresenter}
          >
            <Presenter20Filled className="w-4 h-4 " />
          </button>
        ) : null} */}
        {t("whiteboard.page", { count: currentPage[1] })}
      </div>
    );
  };

  return <>{isPresenter ? renderForAdmin() : renderForParticipant()}</>;
};

export default FooterUI;
